export const CLASS_NAMES = {
  container:
    'flex flex-col rounded-xl border border-neutral-300 px-4 py-6 md:py-10',
  content: '-mb-5 md:-mb-8',
};
